import { loadable } from '@change-corgi/core/react/loadable';

import type { AppRoute } from 'src/shared/routes';

import { Loading } from 'src/app/shared/routes';

export const ROUTES: readonly AppRoute[] = [
	{
		id: 'topic',
		path: '/t-v2/:slug',
		component: loadable(async () => import(/* webpackChunkName: "pages/topic" */ './index'), {
			exportName: 'Topic',
			fallback: Loading,
		}),
		frame: true,
		ssr: {
			enabled: true,
			seo: false,
		},
		restrictedAccess: {
			authOnly: true,
			role: 'staff',
		},
	},
];
